import React from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { store } from 'redux/store';
import { usersApi } from 'services/api/users';
import { setShow, setTitle, setUser } from 'redux/reducers/userModalReducer';
import { handleApiError } from 'helper/error';
import { ResponseError } from 'services/api/base';
import ActionButton from 'components/ActionButton';

export const onClick = async (
  userId: number,
  navigate: NavigateFunction,
) => {
  const { data, error } = await store.dispatch(usersApi.endpoints.getUser.initiate({ id: userId }));
  if (data) {
    store.dispatch(setUser(data));
    store.dispatch(setTitle('Editar Usuário'));
    store.dispatch(setShow(true));
  } else {
    handleApiError(navigate, error as ResponseError);
  }
};

export default function EditUserButton({ userId }: { userId: number }) {
  const navigate = useNavigate();

  return (
    <div className="mx-1 h-100 d-flex align-items-center">
      <ActionButton
        icon="edit"
        onClick={() => {
          onClick(userId, navigate);
        }}
        tooltipText="Editar usuário"
        id={`edit-user-${userId}`}
      />
    </div>
  );
}
